// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__7rEXo","signatureButtonsRight":"ModalSign_signatureButtonsRight__2ZqkN"};